import API_service from 'xAppLib/providers/API_service'

const MODEL_NAME = 'hi_model'

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

const FIELDS = [
    { name: 'sex', label: 'Sex' },
    { name: 'dob', label: 'Date of Birth' },
    { name: 'given_name', label: 'Given Name' },
    { name: 'family_name', label: 'Family Name' },
];

export default class hi_model {
    static get FIELDS() {
        return FIELDS;
    }

    async ihi_lookup(params) { return await API_service.load_data('ihi/lookup', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async ihi_lookup_manual(params) { return await API_service.load_data('ihi/lookup_manual', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async save_ihi(params) { return await API_service.load_data('ihi/save', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async reset_ihi(params) { return await API_service.load_data('ihi/reset', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async load_ihi(params) { return await API_service.load_data('ihi/load', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async ihi_conformance(params) { return await API_service.load_data('ihi/conformance', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async auto_ihi(params) { return await API_service.load_data('ihi/auto_assign', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async verify_ihi(params) { return await API_service.load_data('ihi/verify', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async batch_auto_assign_ihi(params) { return await API_service.load_data('ihi/batch_auto_assign', params) }

    // ----	--------------------------------------------	--------------------------------------------

    async batch_verify_ihi(params) { return await API_service.load_data('ihi/batch_verify', params) }

    // ----	--------------------------------------------	--------------------------------------------

    /**
     *
     * @param {Object} args
     * @param {string} args.uid
     * @returns {Promise<import('../../xAppLib/providers/API_service.types').ApiResult<*>>}
     */
    static get_demo_conflicts({ uid }) {
        return API_service.load_data(`ihi/alerts/get-demo-conflicts/${uid}`)
    }

    /**
     *
     * @param {Object} args
     * @param {string} args.uid
     * @returns {Promise<import('../../xAppLib/providers/API_service.types').ApiResult<*>>}
     */
    static sync_ihi_to_patient({ uid }) {
        return API_service.load_data(`ihi/alerts/sync-ihi-to-patient/${uid}`, {});
    }

    /**
     *
     * @param {Object} args
     * @param {string} args.uid
     * @param {string} args.ihinumber
     * @returns {Promise<import('../../xAppLib/providers/API_service.types').ApiResult<*>>}
     */
    static set_primary_ihi_user({ uid, ihinumber }) {
        return API_service.load_data('ihi/alerts/set-primary-ihi-user', { uid, ihinumber })
    }

    /**
     *
     * @param {Object} args
     * @param {string} args.uid
     * @param {string} args.ihinumber
     * @returns {Promise<import('../../xAppLib/providers/API_service.types').ApiResult<*>>}
     */
    static set_duplicate_ihi_user({ uid, ihinumber }) {
        return API_service.load_data('ihi/alerts/set-duplicate-ihi-user', { uid, ihinumber })
    }

    /**
     * @param {string} [value]
     * @returns {undefined|string}
     */
    static format_ihi(value) {
        if (typeof value === 'string' && value.length === 16) {
            return `${value.slice(0, 4)} ${value.slice(4, 8)} ${value.slice(8, 12)} ${value.slice(12, 16)}`
        }
        return undefined
    }
}
